import React from 'react'
import ScrollUpButton from 'react-scroll-up-button'

const FlowPage = () => (
  <div className='flow'>
    <h2>入居までの流れ</h2>
    <ul className="breadcrumb">
      <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
        <a href="/" itemProp="url">
          <span itemProp="title"><i className="fas fa-home"></i> ホーム</span>
        </a>
      </li>
      <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
        <span itemProp="title"> <i className="fas fa-caret-right"></i> 入居までの流れ</span>
      </li>
    </ul>
    <div className='flow-item'>
      <h3>(1) 利用規約等のご確認</h3>
      <ul>
        <li>必ず、本サイト利用のご契約書に相当する <a href='/termsOfUse'>利用規約</a>ページ をご確認下さい。</li>
        <li>ユーザー様のお問い合わせや面談予約の際の、個人情報のお取り扱いにつきましては、<a href='/privacyPolicy'>プライバシーポリシー</a>ページ に規程しております。</li>
      </ul>
    </div>
    <div className='flow-item'>
      <h3>(2) 物件情報等のご確認</h3>
      <ul>
        <li>物件情報・入居条件・家賃・空室状況・駄菓子屋情報 <i className="fas fa-arrow-right"></i> <a href='/detail'>間取り・家賃</a>ページ</li>
        <li>物件住所および周辺情報 <i className="fas fa-arrow-right"></i> <a href='/access'>アクセス</a>ページ</li>
        <li>駄菓子屋への思い <i className="fas fa-arrow-right"></i> <a href='/shop'>駄菓子屋への思い</a>ページ</li>
        <li>外観や内装のお写真 <i className="fas fa-arrow-right"></i> <a href='/#photos'>PhotoGallery</a>ページ</li>
        <li>その他最新情報 <i className="fas fa-arrow-right"></i> <a href='/#video'>ご紹介動画</a> 、 <a href='/#sns'>各種SNS</a> 、 <a href='/#news'>新着情報</a>ページ</li>
      </ul>
    </div>
    <div className='flow-item'>
      <h3>(3) お問い合わせ</h3>
      <ul>
        <li><a href='/faq'>よくあるご質問</a> ページをご確認の上、お気軽に <a href='/contact'>お問い合わせ</a> ページよりお問い合わせ下さい。</li>
        <li>通常、数日以内にご回答致します。数日経過しても回答がない場合は、お問い合わせの送信に失敗している場合もございますので、お手数おかけしますが、再度お試し下さい。</li>
      </ul>
    </div>
    <div className='flow-item'>
      <h3>(4) 空室状況のご確認および面談予約</h3>
      <ul>
        <li><a href='/detail'>間取り・家賃</a>ページで空室状況をご確認の上、<a href='/contact'>お問い合わせ</a> ページより面談予約を行って下さい。</li>
        <li>通常、数日以内にユーザー様ご指定のメールアドレス または お電話にてご連絡致します。数日経過してもご回答がない場合は、お問い合わせの送信に失敗している場合もございますので、お手数おかけしますが、再度お試し下さい。</li>
      </ul>
    </div>
    <div className='flow-item'>
      <h3>(5) オーナーとのご面談</h3>
      <ul>
        <li>(4) 空室状況のご確認および面談予約 で指定した日時、場所（通常、JR横浜線淵野辺駅隣接の喫茶店）にてオーナーとのご面談を行います。</li>
        <li>ユーザー様のご質問等にお答えした上で、物件情報や入居するまでの流れ等をご説明致します。</li>
        <li>希望者には物件の内覧と現在の入居者様との面談も設定致します（ユーザー様と現在の入居者様の生活を守るために、どちらも入居前に必須となっております）。</li>
      </ul>
    </div>
    <div className='flow-item'>
      <h3>(6) 物件内覧・入居者様とのご面談</h3>
      <ul>
        <li>物件の内覧をして頂きます。</li>
        <li>現在の入居者様とのご面談は、いわゆる面接的な雰囲気ではなく、将来生活を共にするお仲間と気楽にご歓談頂きます。</li>
      </ul>
    </div>
    <div className='flow-item'>
      <h3>(7) 審査結果のご連絡</h3>
      <ul>
        <li>審査の結果は、ご面談後、通常、翌日にユーザー様ご指定のメールアドレス または お電話にご連絡致します。</li>
        <li>ご期待に添えない場合もございますので、予めご了承下さい。</li>
      </ul>
    </div>
    <div className='flow-item'>
      <h3>(8) ご契約の締結</h3>
      <ul>
        <li>(7) 審査結果のご連絡 で指定した日時、場所（通常、JR横浜線淵野辺駅南口の喫茶店）にてご契約締結となります。</li>
        <li>ご契約に必要な書類等は審査結果ご連絡の際に、合わせてご連絡致します。</li>
      </ul>
    </div>
    <div className='flow-item'>
      <h3>(9) ご入金</h3>
      <ul>
        <li>(8) ご契約締結 の指定日までにご入金下さい。入金期限を過ぎますと、失効となりますのでご注意下さい。</li>
      </ul>
    </div>
    <div className='flow-item'>
      <h3>(10) 入居開始</h3>
      <ul>
        <li>入金確認後、(8) ご契約締結 の指定日に入居可能となります。契約締結後にユーザー様のご都合で入居日を変更致しかねますので、ご了承下さい。</li>
      </ul>
    </div>
    <ScrollUpButton style={{width: 30, height: 30}} />
  </div>
)

export default FlowPage


// WEBPACK FOOTER //
// ./src/FlowPage.js